// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Row$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as Chip$Catalyst from "../../../../../../../../../node_modules/@porterin/catalyst/src/components/generic/chip/Chip.bs.js";

function VehicleGeoRegionTitleBar(Props) {
  var vehicle_name = Props.vehicle_name;
  var geo_region = Props.geo_region;
  return React.createElement(Row$Catalyst.make, {
              children: null,
              className: "c-georegion-vehicle-titlebar"
            }, React.createElement(Chip$Catalyst.make, {
                  title: {
                    TAG: /* Text */0,
                    _0: vehicle_name
                  },
                  className: "vehicle-name-chip"
                }), React.createElement("div", {
                  className: "region-name"
                }, geo_region));
}

var make = VehicleGeoRegionTitleBar;

export {
  make ,
  
}
/* react Not a pure module */
